import GUPlanIds from '../../../helper-functions/companies/gu-planids';

const guPlanIds = new GUPlanIds();

export { guPlanIds };
